import { TourInfoScreenEnum } from '@aorg/models/enums/tours/TourInfoScreenEnum';
import { TourTypeEnum } from '@aorg/models/enums/tours/TourTypeEnum';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { TourRedux } from '../models/tours';
import type { RootState } from '../store';

const initialState: TourRedux = {
  isVisible: false,
  isFirst: undefined,
  TypeSelected: undefined,
  ScreenSelected: undefined,
};

const setup = createSlice({
  name: 'tours',
  initialState,
  reducers: {
    ShowTour(
      state,
      {
        payload,
      }: PayloadAction<{
        isFirst: boolean;
        TypeSelected?: TourTypeEnum;
        ScreenSelected?: TourInfoScreenEnum;
      }>
    ) {
      return {
        ...state,
        isVisible: true,
        isFirst: payload.isFirst,
        TypeSelected: payload?.TypeSelected,
        ScreenSelected: payload?.ScreenSelected,
      };
    },
    CloseTour(state) {
      return {
        ...state,
        isVisible: false,
        isFirst: undefined,
        TypeSelected: undefined,
        ScreenSelected: undefined,
      };
    },
  },
});

export const { ShowTour, CloseTour } = setup.actions;

export const selectTour = ({ tours }: RootState) => {
  return tours;
};

export default setup.reducer;
